import { ApplicationState } from '../reducers';
import type { DecisionTreeCurrentStepState } from 'ts/types/decision-tree.types';

export const currentOptionsSelector = (
  state: ApplicationState,
): DecisionTreeCurrentStepState => state.decisionTreeCurrentStep;

export const currentDTQuestionSelector = (state: ApplicationState) =>
  currentOptionsSelector(state).currentOption;
